import { getStrWithCommas } from "../../utils/string";
import { replaceTierLimitsText, sanitizeUpperLimit } from "./pricing-utils";
import tracking from '../../utils/tracking';

const CLS_PREFIX = ".localized_pricing_";
const getEls = (parentNode: HTMLElement) =>
  [
    "heading > .heading",
    "currency_code",
    "price",
    "tier_select",
    "primary_text"
  ].map(sel => parentNode.querySelector(`${CLS_PREFIX}${sel}`));

const populateTierSelector = (tierEl, unitDesc, pricingTiers) =>
  (tierEl.innerHTML = pricingTiers.reduce(
    (domStr, { unitLimitLower, unitLimitUpper, price }) =>
      domStr +
      `<option value="${price}">` +
      `${getStrWithCommas(sanitizeUpperLimit(unitLimitLower, unitLimitUpper))} ${unitDesc}` +
      `</option>`,
    ""
  ));

const onPricing = async (domRoot: HTMLElement, pricing, unitDescription, tierRange) => {
  const [
    headingEl,
    currencyCodeEl,
    priceEl,
    tierSelectEl,
    primaryTextEl
  ] = getEls(domRoot);

  const { currencyCode, pricingTiers } = await pricing;
  let [startTier, endTier] = tierRange.split("-").map(t => parseInt(t));
  const initTier = pricingTiers[startTier];

  [headingEl, primaryTextEl].forEach(
    el => (el.innerText = replaceTierLimitsText(initTier, el.innerText))
  );

  currencyCodeEl.innerText = currencyCode;
  priceEl.innerText = getStrWithCommas(initTier.price);

  populateTierSelector(
    tierSelectEl,
    unitDescription,
    pricingTiers.slice(startTier, endTier)
  );

  tierSelectEl.addEventListener(
    "change",
    ({ target: { value } }) => {
      tracking.trackEvent('datacenter_page_user_tier_box', {
        numberOfUsersSelected: Number(tierSelectEl.selectedOptions[0].innerText.replace(/[^\d]/g, '')),
        priceSelected: Number(value),
        currencyCode: currencyCode,
        eventContainer: 'priceBlockDropdownLocalized',
        eventComponent: 'priceBlockDropdownSelect'
      });
      priceEl.innerText = getStrWithCommas(value)
    }
  );

  domRoot.classList.remove("loading");
};

export default class PriceBlockDropdownLocalized {
  constructor(domRoot: HTMLElement, { pricing, unitDescription, tierRange }) {
    onPricing(domRoot, pricing, unitDescription, tierRange);
  }
}
